<template>
  <component
    :is="type"
    class="button is-text"
    :to="to"
    @click="$emit('onClick')"
  >
    <div>
      <slot />
    </div>
    <div
      v-if="icon_name"
      class="icon text-gray-500"
    >
      <AppIcon :name="icon_name" />
    </div>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { BUTTON_LINK_ACTIONS_TO_ICON } from '@/app/data/button_constants';

const props = defineProps({
  to: { type: Object, default: null },
  action: {
    type: String,
    default: null,
    validator: (prop) => Object.keys(BUTTON_LINK_ACTIONS_TO_ICON).includes(prop),
  },
});

defineEmits(['onClick']);

const type = computed(() => (props.to ? 'AppLink' : 'button'));

const icon_name = computed(() => BUTTON_LINK_ACTIONS_TO_ICON[props.action]);
</script>
